import { render, staticRenderFns } from "./ConfigAvisos.vue?vue&type=template&id=174d2aa4&"
import script from "./ConfigAvisos.vue?vue&type=script&lang=js&"
export * from "./ConfigAvisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports